import React, { Component } from 'react';
// import { Link } from 'gatsby';
import bgPng from 'src/components/events/bg.png';
import bgTextPng from 'src/components/events/bgText.png';
import eventBgPng from 'src/components/events/eventBg.jpg';
// import eventTextPng from 'src/components/events/eventText.png';
import honorPng from 'src/components/events/honor.jpg';
import styled from '@emotion/styled';
import Layout from 'src/layouts/default/default';

const Container = styled.div`
  position: relative;
`;

const Banner = styled.img`
  width: 100%;
`;

const BannerText = styled.img`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const Event = styled.img`
  width: 100%;
`;

const EventText = styled.img`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const Honor = styled.img`
  width: 100%;
`;

export default class Events extends Component {
  componentDidMount() {}

  render() {
    return (
      <Layout
        title="关于高仙-高仙机器人"
        keywords="无人驾驶环卫车_无人扫地车_无人清扫车_安防巡检机器人_SLAM_激光导航-高仙机器人"
      >
        <Container>
          <Banner src={bgPng} alt="关于高仙" title="关于高仙" />
          <BannerText src={bgTextPng} alt="关于高仙" title="关于高仙" />
        </Container>
        <Container>
          <Event src={eventBgPng} alt="高仙大事件" title="高仙大事件" />
          {/* <EventText src={eventTextPng} alt="" /> */}
        </Container>
        <Honor src={honorPng} alt="高仙荣誉" title="高仙荣誉" />
      </Layout>
    );
  }
}
